import useMergeValue from "use-merge-value";
import React, {useMemo, useState} from "react";
import {Button, Popover, Tabs} from "antd";
import {Item, List, PickerPopover, PickerTabs, ServerButton, ServerPickerButton, TabBody} from "./styles";
import {CaretDownOutlined} from "@ant-design/icons";


export type ItemValueType = string | number;
export interface ItemOptionType {
    label: string;
    value: ItemValueType;
}
export interface TabItemOption {
    title: string;
    options: ItemOptionType[];
}
export interface PickerContentProps {
    tabs: TabItemOption[];
    onClick: (value: ItemValueType, item: ItemOptionType) => void;
}
function PickerContent(props: PickerContentProps) {
    const {
        tabs,
        onClick,
    } = props;
    const [active, setActive] = useState<string>();
    return <PickerTabs
        activeKey={active}
        onChange={(v) => {
            setActive(v);
        }}
        style={{
            padding: 0,
        }}
    >
        {tabs.map((tab, index) => {
            const {
                title,
                options
            } = tab;
            return <Tabs.TabPane key={String(index)} tab={tab.title}>
                <TabBody>
                    <List>
                        {options.map((option) => {
                            return <Item key={option.value}>
                                <ServerButton onClick={() => {
                                    onClick?.(option.value, option)
                                }}>
                                    {option.label}
                                </ServerButton>
                            </Item>
                        })}
                    </List>
                </TabBody>
            </Tabs.TabPane>
        })}
    </PickerTabs>
}
export interface PickerProps {
    placeholder?: React.ReactNode;
    value?: ItemValueType | null;
    onSelect?: (value: ItemValueType, item: ItemOptionType) => void;
    tabs: TabItemOption[]
}
function Picker(props: PickerProps) {
    const {
        placeholder,
        value: _value,
        onSelect,
        tabs,
    } = props;
    const [value, setValue] = useMergeValue(undefined as any, {
        value: _value,
        // onChange: onSelect,
    })

    function select(v: ItemValueType, item: ItemOptionType) {
        setValue(v);
        onSelect?.(v, item);
    }
    const labelMap = useMemo<Record<ItemValueType, string>>(() => {
        return tabs.reduce((value, tab) => {
            tab.options.forEach((option) => {
                value[option.value] = option.label;
            })
            return value;
        }, {} as Record<ItemValueType, string>)
    }, [tabs]);

    const [visible, setVisible] = useState<boolean>(false);


    return  <PickerPopover
        overlayClassName={"picker-popover"}
        content={
            <PickerContent tabs={tabs} onClick={(v, item) => {
                select(v, item);
                setVisible(false)
            }} />
        }
        trigger="click"
        placement={"bottom"}
        visible={visible}
        onVisibleChange={(visible) => {
            setVisible(visible)
        }}
    >
        <ServerPickerButton>
            <span>{value ? (labelMap[value]??value) : placeholder}</span>
            <CaretDownOutlined color={"rgb(78, 78, 78)"}/>
        </ServerPickerButton>
    </PickerPopover>

}

export default Picker;